import React, { useState } from 'react'
import {
  Modal,
  Button,
} from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(() => {
  const modal = useModal()

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => modal.remove()}
      dialogPanelClasses="max-w-screen-sm overflow-x-scroll"
      title="Hi there!"
    >
      <div className="space-y-4 mb-4">
        <p>We have noticed that you have not yet signed our updated NDA.</p>
        <p>In order to continue our close collaboration, and to make sure our clients feels confident working with us as a team, we need to get the signed NDA submitted.</p>
        <p>Please review and sign, to continue. Thank you.</p>
        <p>
          Best regards,<br />
          Your Sourcing Team
        </p>
      </div>

      <Button size="sm" onClick={() => modal.remove()}>Review NDA</Button>
    </Modal>
  )
})
